import { render, staticRenderFns } from "./SuketPulangCard.vue?vue&type=template&id=2aa0e59c&"
import script from "./SuketPulangCard.vue?vue&type=script&lang=ts&"
export * from "./SuketPulangCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports